import { addDays, format, parseISO } from 'date-fns';
import { insuredInitiatedMutualCancelReasons } from '@ourbranch/lookups';

// Mirrors policy-mod CANCEL_REASONS_WITHOUT_NOTICE, which enforces the same notice server-side (#36240).
export const CANCEL_REASONS_WITHOUT_NOTICE = [...insuredInitiatedMutualCancelReasons, 'CNRW'];

// Earliest Cancel Effective Date on a brand with a notice period, capped at `latestDate` (term end + 1).
export const earliestCancelEffectiveDate = ({ brandAppConfig, cancelReason, today, latestDate }) => {
  const noticeDays = brandAppConfig?.cancellationNoticeDays;
  if (!noticeDays || !cancelReason || CANCEL_REASONS_WITHOUT_NOTICE.includes(cancelReason)) {
    return undefined;
  }
  const floor = format(addDays(parseISO(today), noticeDays + 1), 'yyyy-MM-dd');
  return latestDate && floor > latestDate ? latestDate : floor;
};

// The Branch non-pay exception group (CNPY_X) keeps its free date choice on the mutuals too.
export const cancelMinDate = ({ canCancelNonPayException, ...floorInput }) =>
  canCancelNonPayException ? undefined : earliestCancelEffectiveDate(floorInput);
